import { render, staticRenderFns } from "./AgreementOther.vue?vue&type=template&id=190013fa&scoped=true&"
import script from "./AgreementOther.vue?vue&type=script&lang=ts&"
export * from "./AgreementOther.vue?vue&type=script&lang=ts&"
import style0 from "./AgreementOther.vue?vue&type=style&index=0&id=190013fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190013fa",
  null
  
)

export default component.exports